import React from "react";
import { Typography, Grid } from "@mui/material";
import { indigo } from "@mui/material/colors";
import { PatientData } from "../../Contexts";
import * as CONST from "../../Constants";
import CallVipLink from "../../layout/CallVipLink";

export default function Greeting() {
  const patient = React.useContext(PatientData);
  return (
    <Grid container direction="row" justifyContent="space-around" alignItems="center">
      <Grid item xs={11} sm={12} px={2} pt={2}>
        <Typography variant="h4" color={indigo[900]} component="div" fontWeight={100}>
          <b fontWeight={600}>{CONST.DASHBOARD.GREETING.HELLO} {patient.first_name},</b>
          <br />
          {CONST.DASHBOARD.GREETING.WELCOME}
          <b fontWeight={600}>{CONST.DASHBOARD.GREETING.yWP}</b>
          {CONST.DASHBOARD.GREETING.DASHBOARD}
        </Typography>
        <Typography variant="body2" color="text.secondary" pt={1}>
          {CONST.DASHBOARD.GREETING.CALL_US}
          <CallVipLink />
        </Typography>
      </Grid>
    </Grid>
  );
}
